module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: ({
        offset: -500
      }),
      expression: "{ offset: -500 }"
    }],
    staticClass: "services"
  }, [_c('header', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content.rendered)
    }
  }), _vm._v(" "), _c('StickyNavigation', {
    attrs: {
      "navigationLinks": _vm.blocks
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg",
    class: _vm.page.acf.hero_picture_position,
    style: ({
      'background-image': 'url( ' + _vm.page.better_featured_image.source_url + ' )',
    })
  })]), _vm._v(" "), [_vm._l((_vm.blocks), function(block, index) {
    return [_c(block.acf_fc_layout, {
      key: index,
      tag: "component",
      attrs: {
        "id": ("link-" + index),
        "blockdata": block,
        "slug": _vm.slug_carousel,
        "post_id": _vm.post_id,
        "pageSlug": _vm.slug
      }
    })]
  })]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42591aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Services.vue
// module id = 332
// module chunks = 0